import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import clsx from "clsx";
import { startCase } from "lodash";
import RedirectComponent from "../../Redirect";

const CustomerProfileRedirect: React.FC<{ label: string; className?: string }> = ({ label, className }) => {
  const { getRouteKey } = useRouter();
  const { customerId, petId } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id")).routeState
    .state as ICustomerProfileState;

  return (
    <p className={clsx("flex justify-start items-center", className)}>
      <span>{startCase(label?.toLowerCase()) ?? "Label"}</span>
      <RedirectComponent
        className="ml-2"
        redirectTo={`${getRouteKey("APPOINTMENTS_TAB", "url")}/${customerId}/${petId}`}
      />
    </p>
  );
};

export default CustomerProfileRedirect;
